import keys from 'lodash/keys';
import pick from 'lodash/pick';

import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { putRequest, displayMessage } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';

import { put, takeEvery, call } from 'redux-saga/effects';

function* listener(serviceType, action) {
  try {
    const model = {
      name:null,
      email:null,
      userID: null,
      userType: null,
      supplierName: null,
      supplierOrLocationId: null,
      contact: null,
      labId: null,
      osh:false,
      facilityOrParentName:null,
      OSHId:null,
      locIds:null,
      litmos:false,
      trainingMaterial:false,
      osIdDeleted:false,
      trainingMaterialDeleted:false,
      deletedAttachments:[],
    };
    
    const result = pick(action.data, keys(model));
    const data = { ...result };
    const infoPopDuration = 1000;
  
    yield call(displayMessage, 'info', 'Submitting your data..', infoPopDuration);
    yield put(createServiceAction(serviceType, 'loading')());
    const res = yield call(putRequest, apiConfig.updateUser.endPointUrl, data);
    // Display HTTP status error message
    const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res, infoPopDuration);
    if(!statusErrorMessage){
      const response = yield res.json();
      // Display server error message
      const serverErrorMessage = yield call(getServerValidationMessage, response, infoPopDuration);
      if (!serverErrorMessage && response.errorCode === 0) {
        yield put(createServiceAction(serviceType, 'success')(response));
        const message = `${response.message}`;
        // Display success message
        yield call(displayMessage, 'success', message, 5000);
        // Dispatch action to update User list (only for admin users)
        if (action.data.userType === 'Rsl' || action.data.userType === 'Nlo') {
          yield put(createServiceAction('userDetails', 'requested')());
        }
        if (action.data.trainingMaterial) {
          yield put(createServiceAction('getUserProfile', 'requested')());
          yield put(createServiceAction('enableTrainingMaterial', 'requested')(false));
        }
      }
    }
  } catch (e) {
    yield put(createServiceAction(serviceType, 'error')(e));
  }
}

function* updateUserProfileSagas() {
 
  const serviceType = 'updateUserProfile';
  yield takeEvery(createServiceAction(serviceType, 'requested').type, listener, serviceType);
}

export default updateUserProfileSagas;
